import { useTranslation } from 'react-i18next';

interface ProFeatureCardProps {
  titleKey: string;
  descriptionKey: string;
}

export function ProFeatureCard({ titleKey, descriptionKey }: ProFeatureCardProps) {
  const { t } = useTranslation();

  return (
    <div className="pro-feature-item flex gap-4">
      <div className="flex-shrink-0 mt-1">
        <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg mb-2">{t(titleKey)}</h3>
        <p className="text-muted-foreground text-sm">{t(descriptionKey)}</p>
      </div>
    </div>
  );
}
